<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text mb-4">
            <div class="text-h4">Documentação para Elaboração das Árvores</div>
        </div>
        <div class="markdown-body light-theme">
            <vue-markdown :options="{ breaks: true }" :linkify="true">{{
                conteudoMarkdown
            }}</vue-markdown>
        </div>
    </v-container>
</template>

<script>
import VueMarkdown from "vue-markdown";
import conteudoMarkdown from "!!raw-loader!@/assets/formato.md";

export default {
    name: "Doc",
    components: {
        "vue-markdown": VueMarkdown,
    },
    data() {
        return {
            conteudoMarkdown: conteudoMarkdown,
        };
    },
};
</script>

<style scoped>
@import "~github-markdown-css/github-markdown.css";

.light-theme {
    background-color: #ffffff;
    color: #24292e;
    padding: 1rem;
    border-radius: 8px;
}

.light-theme a {
    color: #0366d6;
}

.light-theme pre,
.light-theme code {
    background-color: #f6f8fa;
    color: #24292e;
}
</style>
